import { render, staticRenderFns } from "./BulkDeleteBrandPopup.vue?vue&type=template&id=0205c28a&scoped=true&"
import script from "./BulkDeleteBrandPopup.vue?vue&type=script&lang=ts&"
export * from "./BulkDeleteBrandPopup.vue?vue&type=script&lang=ts&"
import style0 from "./BulkDeleteBrandPopup.vue?vue&type=style&index=0&id=0205c28a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0205c28a",
  null
  
)

export default component.exports